import React, { useEffect } from 'react';

/* ─────────────────────────────────────────────
   Modal.jsx  –  reusable overlay modal
   Props:
     open      boolean
     onClose   () => void
     title     string
     children  ReactNode
     width?    number  (default 540)
───────────────────────────────────────────── */

const Modal = ({ open, onClose, title, children, width = 540 }) => {
  /* close on Escape */
  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    if (open) document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: 'rgba(13,13,13,0.55)', backdropFilter: 'blur(4px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 24, animation: 'modalFadeIn 0.18s ease',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#F5F0E8', borderRadius: 12, width: '100%', maxWidth: width,
          maxHeight: '90vh', overflowY: 'auto',
          boxShadow: '0 24px 64px rgba(0,0,0,0.22)',
          animation: 'modalSlideUp 0.2s ease',
        }}
      >
        {/* Header */}
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          padding: '20px 24px 16px',
          borderBottom: '1px solid rgba(42,42,42,0.1)',
        }}>
          <h3 style={{
            fontFamily: '"Cormorant Garamond"', fontSize: 22, fontWeight: 600,
            color: '#191919', margin: 0,
          }}>{title}</h3>
          <button
            onClick={onClose}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              width: 32, height: 32, borderRadius: '50%', display: 'flex',
              alignItems: 'center', justifyContent: 'center',
              color: '#8B8B7A', fontSize: 20, lineHeight: 1,
              transition: 'background 0.15s',
            }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(42,42,42,0.08)'}
            onMouseLeave={e => e.currentTarget.style.background = 'none'}
          >×</button>
        </div>

        {/* Body */}
        <div style={{ padding: '20px 24px 24px' }}>
          {children}
        </div>
      </div>

      <style>{`
        @keyframes modalFadeIn  { from { opacity:0 } to { opacity:1 } }
        @keyframes modalSlideUp { from { transform:translateY(16px); opacity:0 } to { transform:none; opacity:1 } }
      `}</style>
    </div>
  );
};

export default Modal;